module.exports = __webpack_public_path__ + "static/laptop-main-03a553a38150e27b3655d748186c573c.png";